import React, { useState } from "react";
import {
	Container,
	Form,
	Row,
	Col,
	Card,
	CardBody,
	Input,
	CardFooter,
} from "reactstrap";
import regions from "../../constants/regions";

const DefaultRegion = ({ handleSelected, defaultValue }) => {
	const [currentSelected, setCurrentSelected] = useState(defaultValue ?? 1);

	function handleChange(e) {
		var selectedValue = parseInt(e);
		setCurrentSelected(selectedValue);

		handleSelected(selectedValue);
	}

	const styles = {
		content: {
			height: "140px",
			paddingBottom: "12px"
		},
	};

	return (
		<>
			<Container fluid={true}>
				<Form className="d-flex flex-center">
					<Row className="d-flex">
						{regions.map((region, index) => {
							return (
								<Col className="d-flex align-items-center" key={index}>
									<Card style={styles.standard} className="d-flex" onClick={() => handleChange(region.id)}>
										<CardBody
											className="d-flex flex-column text-center pt-1"
											style={styles.content}
										>
											<img src={region.img} alt={region.name} />
										</CardBody>
										<CardFooter
											className="d-flex flex-column text-center pt-1"
											style={{ border: "none" }}
										>
											<span>
												<Input
													type="radio"
													name="radioCounty"
													value={region.id}
													checked={currentSelected === region.id}
												/>
												{region.name}
											</span>
										</CardFooter>
									</Card>
								</Col>
							);
						})}
					</Row>
				</Form>
			</Container>
		</>
	);
};

export default DefaultRegion;
